module.exports = __webpack_public_path__ + "static/img/resume-oblique-projects.6641f1f.png";